import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';
import { InsightsDrawer } from '~/widgets/insight-widget/components/insight-drawer/InsightsDrawer';

export const InsightsDrawerRender = () => {
  const { params } = useQueryParams();

  if (
    params.activeInsight &&
    params[queryKeys.activeDrawer] === queryValues.insightsDrawer
  ) {
    return (
      <ErrorBoundaryWrapper showBorder={false}>
        <InsightsDrawer insightId={params.activeInsight} />
      </ErrorBoundaryWrapper>
    );
  }

  return null;
};
